<script>
    import { transactionStore, clientStore } from '../../stores';
    import { config } from '../../../scripts/defaultURL';
    import { clearForm, formatPayloadDate } from '../../../scripts/functions';
    import { postData } from '../../../scripts/rest';

    export let categoryOptions;

    let payload = {
        income_expense: 'income',
        client_id: $clientStore.client.id,
        date: formatPayloadDate(new Date())
    };

    $: if ($transactionStore) console.log('transactionStore',$transactionStore);

    function closeModal() {
        clearForm('#addTransactionModal input');
        payload = {
            income_expense: 'income',
            client_id: $clientStore.client.id,
            date: formatPayloadDate(new Date())
        }
        document.getElementById('addTransactionModal').classList.remove('is-active')
        if (!$transactionStore) $transactionStore = {};
        $transactionStore['todo'] = 'getData';
    }

    function save() {
        console.log('payload',payload);
  
        postData(`${config.defaultURL}/transactions/add`, payload)
        .catch((error) => console.error('Failed to post scan:', error))
        .then((res) => {
          console.log(res)
          closeModal()
        })
    }
  </script>
  
  <style>
    .modal-card-title {
        margin-bottom: 0 !important;
    }
</style>
    
<div class="modal" id="addTransactionModal">
    <div class="modal-background" />
    <div class="modal-card">
        <header class="modal-card-head">
        <p class="modal-card-title">Add Transaction</p>
        <button on:click={closeModal} class="delete" aria-label="close" />
        </header>
        <section class="modal-card-body">
            <div class="field">
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label class="label">Date</label>
                <input bind:value={payload.date} class="input" type="date" name="date" placeholder="Transaction Date" />
            </div>
            <div class="field">
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label class="label">Amount</label>
                <input bind:value={payload.amount}  class="input" type="numeric" name="amount" placeholder="Transaction amount" />
            </div>
            <div class="field">
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label class="label">Description</label>
                <input bind:value={payload.description} class="input" type="text" name="description" placeholder="Description" />
            </div>
            <div class="field">
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label class="label">Category</label>
                <!-- <input bind:value={payload.category} class="input" type="text" name="category" placeholder="Category" /> -->
                <input list="categories" class="input" name="category" placeholder="Category (optional)" bind:value={payload.category} />
                <datalist id="categories">
                {#each categoryOptions as category}
                <option>{category}</option>
                {/each}
                </datalist> 
            </div>
            <div class="field is-grouped">
                <div class="control">
                    <button on:click={save} class="button is-primary">Save</button>
                </div>
                <div class="control">
                    <button
                    on:click={closeModal}
                    class="button is-primary is-light">Cancel</button>
                </div>
            </div>     
        </section>
    </div>
</div>
    